import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo, Wordmark } from "../components/Logo";
import { apiClient, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await apiClient.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5" data-testid="admin-login-page">
      <div className="glass w-full max-w-md p-10">
        <div className="flex items-center gap-3">
          <Logo className="h-12 w-12" />
          <Wordmark />
        </div>
        <h1 className="mt-8 font-display text-2xl font-bold tracking-tight text-white">Team sign in</h1>
        <p className="mt-2 text-sm text-[#A8B4C2]">Sempresera staff only.</p>
        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="field-label" htmlFor="admin-email">Email</label>
            <input id="admin-email" type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" autoComplete="username" />
          </div>
          <div>
            <label className="field-label" htmlFor="admin-password">Password</label>
            <input id="admin-password" type="password" required className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" autoComplete="current-password" />
          </div>
          {error && (
            <p className="text-sm text-red-400" role="alert" data-testid="admin-login-error">{error}</p>
          )}
          <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-50" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
